/**
 * @author 杨君赫
 * @param
 * 判断是否是Promise，PromiseLike；
 */
export default function isThenable(obj) {
    return (!!obj &&
        (typeof obj === 'object' || typeof obj === 'function') &&
        typeof obj.then === 'function');
}
